const API_BASE_URL = "/Umbraco/Api/MetadataCatalogueSearchResults"

async function apiFetch(endpoint, params, errorContext) {
    try {
        const queryString = new URLSearchParams(params).toString()
        const url = `${API_BASE_URL}/${endpoint}?${queryString}`
        const response = await fetch(url)

        if (!response.ok) {
            throw new Error(`HTTP ${response.status} (${response.statusText})`)
        }

        return await response.json()
    } catch (error) {
        console.error(`Error fetching ${errorContext}:`, error)
        return null
    }
}

export async function fetchDataElementData(variableId, originId) {
    return apiFetch("GetDataElement", { id: variableId, originId }, "variable data")
}

export async function fetchTableElementData(catalogueId, tableId, originId, pageNumber = 1) {
    return apiFetch(
        "GetDataCatalogueTable",
        { catalogueId, tableId, originId, pageNumber },
        "data dictionary table"
    )
}
